module.exports = new __parcel__URL__("remove_points_button.0c1fe3b9.png").toString();